import axios from "../../utils/axiosInstance";

// Fields mode — sends the AdobeQuoteRequest model as JSON
export const sendAdobeQuote = async (jsonObj) => {
    return await axios.post("/createAdobeQuote", jsonObj, {
        headers: { 'content-type': 'application/json' }
    });
};

// Raw JSON mode — sends a fully-populated JSON object + a .docx template file
export const sendAdobeQuoteRaw = async (jsonObj, docxFile) => {
    const formData = new FormData();
    formData.append('jsonData', JSON.stringify(jsonObj));
    formData.append('file', docxFile);

    return await axios.post("/createAdobeQuoteRaw", formData, {
        headers: { 'content-type': 'multipart/form-data' }
    });
};

// Upload a .docx (and optionally .html) template for a given scenario
export const uploadAdobeQuoteTemplate = async (scenario, rows, docxFile, htmlFile) => {
    const formData = new FormData();
    formData.append('scenario', scenario);
    formData.append('rows', rows);
    formData.append('docx', docxFile);
    formData.append('html', htmlFile);

    return await axios.post('/uploadAdobeQuoteTemplate', formData, {
        headers: { 'content-type': 'multipart/form-data' }
    });
};

// Fetch the most recent valid currency conversion rate snapshot from the DB
export const getLatestCurrencyConversionRate = async () => {
    return await axios.post("/getLatestCurrencyConversionRate", {}, {
        headers: { 'content-type': 'application/json' }
    });
};